import React from 'react';
import SiteMessageContainer from './SiteMessageContainer';

/**
 * GlobalMessages Component
 *
 * Displays site-wide messages that target "All Pages"
 * This component should be placed at the app root level to show messages everywhere
 */
const GlobalMessages = () => {
  return (
    <div className="fixed top-16 left-0 right-0 z-40 pointer-events-none">
      <div className="container mx-auto px-4 lg:px-8 pt-4 pointer-events-auto">
        <SiteMessageContainer page="all" variant="compact" maxMessages={1} />
      </div>
    </div>
  );
};

export default GlobalMessages;
